import { render, staticRenderFns } from "./TemplateJourneyEdit.vue?vue&type=template&id=5362dddd&scoped=true"
import script from "./TemplateJourneyEdit.vue?vue&type=script&lang=js"
export * from "./TemplateJourneyEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateJourneyEdit.vue?vue&type=style&index=0&id=5362dddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362dddd",
  null
  
)

export default component.exports